import { defineStore, acceptHMRUpdate } from 'pinia'
import useState from './useState'
import useGetters from './useGetters'
import useActions from './useActions'
import { unref } from 'vue'

export const useGlobalStore = defineStore('globalStore', () => {
  const store = {
    initialState: unref(useState()),
    ...useState(),
    ...useGetters(),
    ...useActions()
  }
  // useWatchers(store)
  return store
}, { persist: { pick: ['dark', 'lang'] } })

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useGlobalStore, import.meta.hot))
}
